import { z } from 'zod';
import { localDate } from './common.js';
export const trendsQuery = z.object({
    days: z.coerce.number().int().min(7).max(365).default(30),
    to: localDate.optional(),
});
/**
 * Which streak number a screen shows, and whether it is being held for today.
 *
 * ONE RULE, IMPORTED BY BOTH SCREENS. Home and Trends each render the streak,
 * and two screens deciding separately which number to put up is exactly how
 * this app has repeatedly ended up saying two things about one day.
 */
export function shownStreak(s) {
    if (s.current > 0)
        return { days: s.current, held: false };
    const held = s.resumable ?? null;
    return held !== null && held > 0 ? { days: held, held: true } : { days: 0, held: false };
}
export const generateReport = z.object({
    /** Monday of the week to report on. Defaults to the week just finished. */
    weekStart: localDate.optional(),
    regenerate: z.boolean().default(false),
});
//# sourceMappingURL=insights.js.map